/*
 * Project: BookingEngine
 * Module: PaymentBookDetails.js
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import formatCurrency from 'format-currency';

import type { BookingType, Currency } from '../../../FlowTypes';

const PaymentBookDetails = (props: { booking: ?BookingType, currency: Currency }, context: { t: () => {}}) => (
  <div className="PaymentBookDetails">
    <div className="row">
      <div className="col-md-12">
        <b>{context.t('Reservation details')}</b>
      </div>
      <div className="col-md-2"><strong>{context.t('Name')}</strong>:</div>
      <div className="col-md-4">{props.booking.cli_full_name}</div>
      <div className="col-md-2"><strong>{context.t('Email')}:</strong></div>
      <div className="col-md-4">{props.booking.cli_email}</div>
      <div className="col-md-2"><strong>{context.t('Booking reference')}:</strong></div>
      <div className="col-md-4">{props.booking.locator}</div>
      <div className="col-md-2"><strong>{context.t('Amount')}:</strong></div>
      <div className="col-md-4">{formatCurrency(props.booking.amount, props.currency)}</div>
      <div className="col-md-2"><strong>{context.t('Status')}:</strong></div>
      <div className="col-md-10">{props.booking.status_display}</div>
    </div>
    {props.errorMsg && <div className="PaymentError">{props.errorMsg}</div>}
  </div>
);

PaymentBookDetails.contextTypes = {
  t: PropTypes.func.isRequired,
};

PaymentBookDetails.propTypes = {
  booking: PropTypes.object.isRequired,
  errorMsg: PropTypes.string,
};

export default PaymentBookDetails;
